import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckoutStep } from '@interfaces/generic/checkout-step.interface';

@Component({
  selector: 'checkout-steps',
  templateUrl: './checkout-steps.component.html',
  styleUrls: ['./checkout-steps.component.scss'],
})
export class CheckoutStepsComponent {
  @Input() currentStep: CheckoutStep;
  @Input() steps: CheckoutStep[] = [];

  @Output() changeStep = new EventEmitter<CheckoutStep>();

  public onClickOnStep(step: CheckoutStep) {
    this.changeStep.emit(step);
  }
}
